import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../hooks/useStore';
import { DataViewEditBox } from '../../../../lib/components';
import { SingleSignOnSettingsView, SingleSignOnData } from './view';

interface ManageSingleSignOnProps {
  singleSignOnData: SingleSignOnData;
}

const ManageSingleSignOn = observer(({ singleSignOnData }: ManageSingleSignOnProps) => {
  const { t } = useTranslation();
  const renderView = () => <SingleSignOnSettingsView data={singleSignOnData} />;

  return (
    <DataViewEditBox
      title={singleSignOnData.platform ? t(`auth:PLATFORM_LOGIN`) : t(`auth:APP_LOGIN`)}
      view={renderView}
      edit={() => <></>}
      canEdit={false}
      canSubmit={false}
    />
  );
});

export const ManageAppSingleSignOn = observer(() => {
  const { companyStore } = useStore();

  const singleSignOnData = {
    single_sign_on_enabled: companyStore.settings?.app_single_sign_on_enabled ?? false,
    password_auth_enabled: companyStore.settings?.app_password_auth_enabled ?? false,
    platform: false
  };

  return <ManageSingleSignOn singleSignOnData={singleSignOnData} />;
});

export const ManagePlatformSingleSignOn = observer(() => {
  const { companyStore } = useStore();

  const singleSignOnData = {
    single_sign_on_enabled: companyStore.settings?.platform_single_sign_on_enabled ?? false,
    password_auth_enabled: companyStore.settings?.platform_password_auth_enabled ?? false,
    platform: true
  };

  return <ManageSingleSignOn singleSignOnData={singleSignOnData} />;
});
